import {postRequest, deleteRequest} from './request';

export function createSite(site) {
  return postRequest('/api/v1/site', site);
}

export function deleteSite(id) {
  return deleteRequest(`/api/v1/site/${id}`);
}
